import {useState} from "react";

import {Button} from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {Loader} from "@/src/modules/core/components";

import useHelpDomain from "../hooks/use-help-domain";
import {renderHelpText} from "../lib/render-help-text";

type LearnMoreLinkProps = {
  domain: string;
  sectionId: string;
  label?: string;
};

export function LearnMoreLink({domain, sectionId, label = "Learn more"}: LearnMoreLinkProps) {
  const [open, setOpen] = useState(false);
  const {data: bundle, isPending, isError} = useHelpDomain(domain, open);

  const section = bundle?.sections.find((item) => item.id === sectionId);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        render={
          <Button type="button" variant="link" className="h-auto p-0 text-xs">
            {label}
          </Button>
        }
      />
      <DialogContent className="max-h-[min(80vh,32rem)] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{section?.title ?? "Help"}</DialogTitle>
        </DialogHeader>
        {isPending ? <Loader className="py-8" /> : null}
        {isError ? (
          <p className="text-sm text-muted-foreground">Could not load help content.</p>
        ) : null}
        {section ? renderHelpText(section.body) : null}
        {!isPending && !isError && !section ? (
          <p className="text-sm text-muted-foreground">Section not found.</p>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
